import {useEffect, useState} from "react";
import type {Socket} from "socket.io-client";
import {io} from "socket.io-client";

export const useWebSocket = (url: string, init?: boolean) => {
    const [ws, setWS] = useState<Socket | undefined>();

    useEffect(() => {
        if (init) {
            const socket = io(url, {
                withCredentials: true,
                transports: ["websocket"]
                // ...options,
            });

            socket.on("connect_error", err => {
                if (__DEV__) {
                    console.warn(`connect_error due to ${err.message}`);
                }
            });
            socket.on("connect", () => {
                if (__DEV__) {
                    console.log("websocket connected!");
                }
                // it actually subscribes the events as it has been connected
                setWS(socket);
            });
            socket.on("disconnect", () => {
                if (__DEV__) {
                    console.log("websocket disconnected :(");
                }
            });
        }
    }, [init, url]);

    useEffect(() => {
        return () => {
            if (ws) {
                ws.disconnect();
                ws.close();
            }
        };
    }, [ws]);

    return ws;
};
